export default "__VITE_ASSET__CkX5n43L__"